import React, {Component} from "react";
import {BrowserRouter as Router, Route, NavLink, HashRouter, Switch, Redirect} from "react-router-dom";
import {connect} from "react-redux";
import * as R from "ramda";

import NotifPopup from "../modules/popup/Notif";
import ProfilePopup from "../modules/popup/Profile";
import logoNagamas from "../assets/img/logo-nagamas.png";

// auth
import Login from "./auth/Index";

// home
import DashboardEmployee from "./dashboard/newDashboard/dashboardEmployee";

//masterdata
import User from "./masterData/user/user/user";
import Bank from "./masterData/bank/bank/bank";
import jasa from "./masterData/jasa/jasa/jasa";
import receivingUnit from "./h1Module/receivingunit/receivingUnit/receivingUnit";
import receivingPart from "./h3Module/receivingPart/receivingPart/receivingPart";
import warehouse from "./masterData/warehouse/warehouse/warehouse";
import pit from "./masterData/pit/pit/pit";
import supplier from "./masterData/supplier/supplier/supplier";
import units from "./masterData/units/units/units";
import notifikasi from "./masterData/notifikasi/notifikasi/notifikasi";
import samsat from "./masterData/samsat/samsat/samsat";
import part from "./masterData/part/part/part";
import ksu from "./h1Module/ksu/ksu/ksu";
import _return from "./h1Module/return/return/return";
import access from "./masterData/access/access/access";
import leasing from "./masterData/leasing/leasing/leasing";
import procurement from "./h3Module/procurement/procurement/procurement";
import pricelist from "./masterData/pricelist/pricelist/pricelist";
import discount from "./masterData/discount/discount/discount";
import mksu from "./masterData/mksu/mksu/mksu";
import payment from "./h1Module/payment/payment/payment";
import paymentH3 from "./h3Module/payment/payment/payment";

//masterdata
import Cabang from "./masterData/cabang/cabang/cabang";
import varian from "./masterData/master-series/varian/varian";
import delivery from "./h1Module/delivery/delivery/delivery";
import miscInOut from "./h3Module/miscInOut/miscInOut/miscInOut";
import MiscInOutH1 from "./h1Module/miscInOut/miscInOut/miscInOut";
import inventoryh3 from "./h3Module/inventory/inventory/inventory";
import unitMovementh3 from "./h3Module/unitMovement/unitMovement/unitMovement";
import inventory from "./h1Module/inventory/inventory/inventory";
import unitMovement from "./h1Module/unitMovement/unitMovement/unitMovement";
import voucher from "./masterData/voucher/voucher/voucher";
import stockOpname from "./h1Module/stockOpname/stockOpname/stockOpname";
import DashboardUserManagement from "./dashboard/newDashboard/dashboardUserManagement";
import DashboardBankManagement from "./dashboard/newDashboard/dashboardBankManagement";
import DashboardVarian from "./dashboard/newDashboard/dashboardVarian";
import DashboardBranch from "./dashboard/newDashboard/dashboardBranch";
import DashboardRecUnit from "./dashboard/newDashboard/dashboardRecUnit";
import DashboardDelivery from "./dashboard/newDashboard/dashboardDeliver";
import DashboardRecPart from "./dashboard/newDashboard/dashboardRecPart";
import dashboardMSIC from "./dashboard/newDashboard/dashboardMSIC";
import dashboardUnitMovement from "./dashboard/newDashboard/dashboardUnitMovement";
import dashboardMasterJasa from "./dashboard/newDashboard/dashboardMasterJasa";
import dashboardWarehouse from "./dashboard/newDashboard/dashboardWarehouse";
import dashboardPit from "./dashboard/newDashboard/dashboardPit";
import order from "./h1Module/order/order/order";
import parameter from "./masterData/parameter/parameter/parameter";
import wilayah from "./masterData/wilayah/wilayah/wilayah";
import item from "./masterData/item/item/item";
import receivingItems from "./h3Module/receivingItem/receivingPart/receivingItems";
import PDI from "./h2Module/delivery/delivery/PDI";
import stockOpnameh3 from "./h3Module/stockOpname/stockOpname/stockOpname";
import promo from "./masterData/promo/promo/promo";
import reportH2 from "./h2Module/report/report/reportH2";
import reportH3 from "./h3Module/report/report/reportH3";
import reportH1 from "./h1Module/report/report/reportH1";
import fandb from "./h1Module/fandb/fandb/fandb";
import poin from "./masterData/poin/poin/poin";
import data from "./h1Module/data/data/data";
import _package from "./masterData/package/package/package";
import kas from "./h1Module/kas/kas/kas";
import prospek from "./h1Module/prospek/prospek/prospek";
import prospekH3 from "./h3Module/prospek/prospek/prospek";
import batery from "./masterData/batery/batery/batery";
import workOrder from "./h2Module/workOrder/workOrder/workOrder";
import claimC3 from "./h2Module/claimC3/claimC3/claimC3";
import claimC1 from "./h1Module/claimC1/claimC1/claimC1";
import MasterUser from "./config/masterUser/masterUser";
import MasterCabang from "./config/masterCabang/masterCabang";
import MasterHirarki from "./config/masterHirarki/masterHirarki";
import MasterSuppliers from "./config/masterSuppliers/masterSuppliers";
import MasterLogistikMotor from "./config/masterLogistikMotor/masterLogistikMotor";
import MasterLogistikNonMotor from "./config/masterLogistikNonMotor/masterLogistikNonMotor";
import MasterLocator from "./config/masterLocator/masterLocator";
import MasterParameter from "./config/masterParameter/masterParameter";
import MasterKas from "./config/masterKas/masterKas";
import MasterSamsat from "./config/masterSamsat/masterSamsat";
import AccessMenuSetting from "./config/accessMenuSetting/accessMenuSetting";
import ReceivingUnit from "./config/inventory/receivingUnit/receivingUnit";
import ReceivingKSU from "./config/inventory/receivingKSU/receivingKSU";
import ReceivingItem from "./config/inventory/receivingItem/receivingItem";
import InventoryStock from "./config/inventory/inventorystock/inventoryStock";
import StockOpname from "./config/stockOpname/stockOpname";
import MasterBank from "./config/masterBank/masterBank";
import MasterPart from "./config/masterPart/masterPart";
import MasterLeasing from "./config/masterLeasing/masterLeasing";
import MasterApproval from "./config/masterApproval/masterApproval";
import MutasiBarang from "./config/mutasiBarang/mutasiBarang";
import POUnit from "./config/poUnit/poUnit";
import ClaimC1 from "./config/claimC1/claimC1";

import MasterUnitPrice from "./config/masterUnitPrice/masterUnitPrice";
import ErrorAlert from "../modules/commons/ErrorAlert";
import MasterPackage from "./config/masterPackage/masterPackage";
import MasterBBN from "./config/masterBBN/masterBBN";
import PenyerahanBBN from "./config/penyerahanBBN/penyerahanBBN";
import ProsesSamsat from "./config/prosesSamsat/prosesSamsat";
import ProsesSSU from "./config/prosesSSU/prosesSSU";
import MasterPenjualan from "./config/masterPenjualan/masterPenjualan";
import IndentUnit from "./config/indentUnit/indentUnit";
import DeliveryConfirmed from "./config/deliveryConfirmed/deliveryConfirmed";
import Pdi from "./config/PDI/pdi";
import SalesOrder from "./config/salesOrder/penagihanLeasing/salesOrder";
import TransaksiBank from "./config/payment/transaksiBank/transaksiBank";
import TransaksiCash from "./config/payment/transaksiCash/transaksiCash";
import Ekspedisi from "./config/ekspedisi/ekspedisi";
import CustomerProfileCDB from "./config/customerProfileCDB/customerProfileCDB";
import CRMAssign from "./config/crm/assign/crmAssign";
import MasterPromo from "./config/masterPromo/masterPromo";
import MasterVoucher from "./config/masterVoucher/masterVoucher";
import FakturJual from "./config/salesOrder/fakturJual/fakturJual";
import CRMFollowUp from "./config/crm/followUp/crmFollowUp";
import ManagementNotif from "./config/managementNotif/managementNotif";
import CrmCDB from "./config/crm/cdb/crmCDB";
import DashboardTeamLeader from "./config/dashboard/dashboardTeamLeader/dashboardTeamLeader";
import DashboardCashier from "./config/dashboard/dashboardCashier/dashboardCashier";
import DashboardSales from "./config/dashboard/dashboardSales/dashboardSales";
import SalesReport from "./config/dashboard/dashboardSales/component/salesReport";
import VariantReport from "./config/dashboard/dashboardSales/component/variantReport";
import DashboardKacab from "./config/dashboard/dashboardKacab/dashboardKacab";
import KacabReportByCabang from "./config/dashboard/dashboardKacab/dashboardKacabByCabang/kacabReportByCabang";
import KacabReportByTL from "./config/dashboard/dashboardKacab/dashboardKacabByTL/kacabReportByTL";
import KacabReportBySalesman from "./config/dashboard/dashboardKacab/dashboardKacabBySalesman/kacabReportBySalesman";
import KacabReportByType from "./config/dashboard/dashboardKacab/dashboardKacabByType/kacabReportByType";
import KacabReportByTypeByTL from "./config/dashboard/dashboardKacab/dashboardKacabByTypeByTL/kacabReportByTypeByTL";
import KacabReportBySalesComposition
    from "./config/dashboard/dashboardKacab/dashboardKacabBySalesComposition/kacabReportBySalesComposition";
import KacabReportBySalesStructure
    from "./config/dashboard/dashboardKacab/dashboardKacabBySalesStructure/kacabReportBySalesStructure";
import KacabReportByIndent from "./config/dashboard/dashboardKacab/dashboardKacabByIndentReport/kacabReportByIndent";
import TLReportByTL from "./config/dashboard/dashboardTeamLeader/dashboardTLbyTL/TLReportByTL";
import TLReportBySalesman from "./config/dashboard/dashboardTeamLeader/dashboardTLbySalesman/TLReportBySalesman";
import TLReportByVariant from "./config/dashboard/dashboardTeamLeader/dashboardTLbyVariant/TLReportByVariant";
import DashboardCrmCoordinator from './config/dashboard/dashboardCrmCoordinator/dashboardCrmCoordinator'
import DashboardCrmCoordinatorByTL
    from "./config/dashboard/dashboardCrmCoordinator/dashboardCrmCoordinatorByTL/dashboardCrmCoordinatorByTL";
import DashboardCrmCoordinatorDailyReport
    from "./config/dashboard/dashboardCrmCoordinator/dashboardCrmCoordinatorDaily/dashboardCrmCoordinatorDaily";
import DashboardAccounting from "./config/dashboard/dashboardAccounting/dashboardAccounting";
import DashboardCrmSalesman from "./config/dashboard/dashboardCrmSalesman/dashboardCrmSalesman";
import ProspectMonitoringTeam
    from "./config/dashboard/dashboardCrmSalesman/prospectMonitoringTeam/prospectMonitoringTeam";
import ProspectDaily from "./config/dashboard/dashboardCrmSalesman/prospectDaily/prospectDaily";
import DashboardKacabAdminCrm from "./config/dashboard/dashboardKacabAdminCrm/dashboardKacabAdminCrm";
import ProspectMonitoringCrm from "./config/dashboard/dashboardKacabAdminCrm/prospectMonitoring/prospectMonitoring";
import ProspectMonitoringTeamCrm
    from "./config/dashboard/dashboardKacabAdminCrm/prospectMonitoringTeam/prospectMonitoringTeam";
import ProspectDailyCrm from "./config/dashboard/dashboardKacabAdminCrm/prospectDaily/prospectDaily";
import ProspectMonitoringROCrm
    from "./config/dashboard/dashboardKacabAdminCrm/prospectMonitoringRO/prospectMonitoringRO";
import MutasiPart from "./config/mutasiPart/mutasiPart";
import MasterService from "./config/masterService/masterService";
import ReceivingPart from "./config/receivingParts/receivingParts";
import ManagementApproval from "./config/managementApproval/managementApproval";
import managementNRFS from "./config/managementNRFS/managementNRFS";
import ManagementNRFS from "./config/managementNRFS/managementNRFS";
import MasterCOA from "./config/masterCOA/masterCOA";
import MasterSopir from "./config/masterSopir/masterSopir";
import MasterMekanik from './config/masterMekanik/masterMekanik'
import MasterBooking from "./config/masterBooking/masterBooking";
import MasterPartPrice from "./config/masterPartPrice/masterPartPrice";
import MasterAcuanStock from "./config/masterAcuanStock/masterAcuanStock";
import MasterHargaJasa from "./config/masterHargaJasa/masterHargaJasa";
import MasterPromoH2 from "./config/masterPromoH2/masterPromoH2";

import ManagementMekanik from './config/managementMekanik/managementMekanik'
import ManagementBooking from './config/managementBooking/managementBooking'
import CrmFollowUpH23 from "./config/crmh23/followup/crmFollowUpH23";
import MasterPackageH2 from "./config/masterPackageH2/masterPackageH2";
import FakturJualBengkel from "./config/fjb/fakturJualBengkel";
import ManagementClaim from "./config/managementClaim/managementClaim";
import InventoryPart from "./config/inventoryH23/inventoryPart/inventoryPart";
import PoPart from "./config/poPart/poPart";
import DashboardCRMKabengKacab from "./config/dashboardH23/dashboardCRMKabengKacab/dashboardCrmKabengKacab";
import DashboardProspekMonitoringKabengKacab from "./config/dashboardH23/dashboardCRMKabengKacab/dashboardProspekMonitoringKabengKacab/dashboardProspekMonitoringKabengKacab";
import DashboardProspekDailyKabengKacab from "./config/dashboardH23/dashboardCRMKabengKacab/dashboardProspekDailyKabengKacab/dashboardProspekDailyKabengKacab";
import DashboardMonitoringROKabengKacab from "./config/dashboardH23/dashboardCRMKabengKacab/dashboardMonitoringROKabengKacab/dashboardMonitoringROKabengKacab";
import DashboardMonitoringTambahanKabengKacab from "./config/dashboardH23/dashboardCRMKabengKacab/dashboardMonitoringTambahanKabengKacab/dashboardMonitoringTambahanKabengKacab";
import DashboardMonitoringKPBKabengKacab from "./config/dashboardH23/dashboardCRMKabengKacab/dashboardMonitoringKPBKabengKacab/dashboardMonitoringKPBKabengKacab";
import DashboardLevelMekanikSA from "./config/dashboardH23/dashboardLevelMekanikSA/dashboardLevelMekanikSA";
import DashboardLaporanHarianPartByMekanikdanSA from "./config/dashboardH23/dashboardLevelMekanikSA/dasboardLaporanHarianPartByMekanikdanSA/dashboardLaporanHarianPartByMekanikdanSA";
import DashboardLaporanHarianUnit from "./config/dashboardH23/dashboardLevelMekanikSA/laporanHarianUnit/laporanHarianUnit";
import DashboardLevelKabengKeatas from "./config/dashboardH23/dashboardLevelKabengKeatas/dashboardLevelKabengKeatas";
import DashboardLaporanHarianPartByCabang from "./config/dashboardH23/dashboardLevelKabengKeatas/dashboardLaporanHarianPartByCabang/dashboardLaporanHarianPartByCabang";
import DashboardLaporanHarianUnitByCabang from "./config/dashboardH23/dashboardLevelKabengKeatas/dashboardLaporanHarianUnitByCabang/dashboardLaporanHarianUnitByCabang";
import DashboardLaporanHarianUnitByMekanik from "./config/dashboardH23/dashboardLevelKabengKeatas/dashboardLaporanHarianUnitByMekanik/dashboardLaporanHarianUnitByMekanik";
import DashboardLaporanHarianPartByMekanik from "./config/dashboardH23/dashboardLevelKabengKeatas/dashboardLaporanHarianPartByMekanik/dashboardLaporanHarianPartByMekanik";
import DashboardLaporanTambahan from "./config/dashboardH23/dashboardLevelKabengKeatas/dashboardLaporanTambahan/dashboardLaporanTambahan";
// icon
var angle = "fa fa-lg fa-angle-right";
var close = "fa fa-lg fa-times";

// sub menu
var opSubMenu = "app-menu app-submenu-themes app-submenu";
var clSubMenu = "app-menu app-submenu-themes";

var opMenu = "list";
var clMenu = "list active";

class App extends Component {
    constructor() {
        super();
        this.state = {
            appClass: "app", //app-side-big-icon
            appButtonClass: "fa fa-lg fa-times",
            travelClass: opMenu,
            travelSubmenu: opSubMenu,
            travelMoreIcon: angle,
            timeClass: opMenu,
            timeSubmenu: opSubMenu,
            timeMoreIcon: angle,
            leaveClass: opMenu,
            leaveSubmenu: opSubMenu,
            leaveMoreIcon: angle,
            overtimeClass: opMenu,
            overtimeSubmenu: opSubMenu,
            overtimeMoreIcon: angle,
            employeeClass: opMenu,
            employeeSubmenu: opSubMenu,
            employeeMoreIcon: angle,

            privilegeReady: false,
            lastMenuData: "",
            menuData: [],
        };
    }

    opEmployeeSubmenu = () => {
        if (this.state.employeeClass === opMenu) {
            this.setState({employeeSubmenu: clSubMenu});
            this.setState({employeeClass: clMenu});
            this.setState({employeeMoreIcon: close});
        } else {
            this.setState({employeeSubmenu: opSubMenu});
            this.setState({employeeClass: opMenu});
            this.setState({employeeMoreIcon: angle});
        }
    };

    opTravelSubmenu = () => {
        if (this.state.travelClass === opMenu) {
            this.setState({travelSubmenu: clSubMenu});
            this.setState({travelClass: clMenu});
            this.setState({travelMoreIcon: close});
        } else {
            this.setState({travelSubmenu: opSubMenu});
            this.setState({travelClass: opMenu});
            this.setState({travelMoreIcon: angle});
        }
    };

    opTimeSubmenu = () => {
        if (this.state.timeClass === opMenu) {
            this.setState({timeSubmenu: clSubMenu});
            this.setState({timeClass: clMenu});
            this.setState({timeMoreIcon: close});
        } else {
            this.setState({timeSubmenu: opSubMenu});
            this.setState({timeClass: opMenu});
            this.setState({timeMoreIcon: angle});
        }
    };

    opLeaveSubmenu = () => {
        if (this.state.leaveClass === opMenu) {
            this.setState({leaveSubmenu: clSubMenu});
            this.setState({leaveClass: clMenu});
            this.setState({leaveMoreIcon: close});
        } else {
            this.setState({leaveSubmenu: opSubMenu});
            this.setState({leaveClass: opMenu});
            this.setState({leaveMoreIcon: angle});
        }
    };

    opOvertimeSubmenu = () => {
        if (this.state.overtimeClass === opMenu) {
            this.setState({overtimeSubmenu: clSubMenu});
            this.setState({overtimeClass: clMenu});
            this.setState({overtimeMoreIcon: close});
        } else {
            this.setState({overtimeSubmenu: opSubMenu});
            this.setState({overtimeClass: opMenu});
            this.setState({overtimeMoreIcon: angle});
        }
    };

    opSlide = () => {
        if (this.state.appClass === "app") {
            this.setState({appClass: "app app-side-big-icon"});
            this.setState({appButtonClass: "fa fa-lg fa-bars"});
        } else {
            this.setState({appClass: "app"});
            this.setState({appButtonClass: "fa fa-lg fa-times"});
        }
    };

    createList = () => {
        let dt = [];

        for (let i = 0; i < 10; i++) {
            dt.push(
                <NavLink to={"/components/" + i}>
                    <li className="content">
                        <div className="list">
                            <div className="icn">
                                <i className="fa fa-lg fa-th"></i>
                            </div>
                            <div className="ttl">Components {i}</div>
                        </div>
                    </li>
                </NavLink>
            );
        }

        return dt;
    };

    createSubMenu = (val, link, icon) => {
        return (
            <NavLink to={link}>
                <div className="content">
                    <div className="list">
                        <div className="icn">
                            <i className={`${icon} fa-lg`}></i>
                        </div>
                        <div className="ttl">{val}</div>
                        <div className="icn icn-right txt-site txt-right txt-12"></div>
                    </div>
                </div>
            </NavLink>
        );
    };

    createHomeMenu = (val, link, img) => {
        return (
            <NavLink to={link}>
                <div className="content" style={{color: "red"}}>
                    <div className="list">
                        <div className="img">
                            <i className={`${img}`}></i>
                        </div>
                        <div className="ttl">{val}</div>
                        <div className="img img-right txt-site txt-right txt-12"></div>
                    </div>
                </div>
            </NavLink>
        );
    };

    checkPermissionSubMenu = (valMenu, valSubmenu) => {
        //static response for the moment,
        //will be activated later when authorization is ready to use
        // return true;
        let iter = 1;
        for (let indexData in this.state.menuData) {
            iter++;
            let item = this.state.menuData[indexData];

            if (item.menuParentName === valMenu) {
                if (item.menuName === valSubmenu) {
                    return true;
                }
            }
        }
        return false;
    };

    checkPermissionMenu = (val) => {
        // return true;
        let isFound = false;
        for (let indexData in this.state.menuData) {
            let item = this.state.menuData[indexData];
            if (item.menuParentName === val) {
                isFound = true;
                break;
            }
        }
        return isFound;
    };

    checkPermissionMenuDashboard = (val) => {
        // return true;
        let isFound = false;
        for (let indexData in this.state.menuData) {
            let item = this.state.menuData[indexData];
            if (item.menuId === val) {
                let index = R.findIndex(R.propEq("formId", "DASHBOARD-001"))(item.listForm);
                isFound = index >= 0 ? true : false;
                break;
            }
        }
        return isFound;
    };

    getMenuAccess = () => {
        if (this.props.auth && this.props.auth.user != null && !this.props.auth.error) {
            // console.log(this.props.auth.user);
            // console.log("---1----"+this.props.auth.user.jwtToken);
            if (this.state.lastMenuData !== this.props.auth.user.jwtToken) {
                //dont update after being initialized
                if (this.state.menuData.length === 0 && this.props.auth.user.listMenu) {
                    this.setState({
                        menuData: this.props.auth.user.listMenu,
                        lastMenuData: this.props.auth.user.jwtToken,
                        userCategory: this.props.auth.user.userCategory,
                    });
                } else {
                    this.setState({
                        menuData: [],
                        lastMenuData: this.props.auth.user.jwtToken,
                        userCategory: this.props.auth.user.userCategory,
                    });
                    return false;
                }
            }
        } else {
            // console.log("--------1111-------------");
            if (this.state.lastMenuData.trim() === "") {
                // console.log("--------1113-------------");
            } else {
                //backup store
                let authStore = localStorage.getItem("authStore");
                if (R.isNil(authStore)) {
                    this.setState({
                        menuData: [],
                        lastMenuData: "",
                    });
                } else {
                    authStore = JSON.parse(authStore);
                    this.setState({
                        menuData: authStore.listMenu,
                        lastMenuData: authStore.jwtToken,
                    });
                }
            }
        }
        // console.log('----------------MENU------------');
        // console.log(this.state.menuData);
    };

    getMenuAccessForUser = (parent, child, index) => {
        if (this.props.auth && this.props.auth.user && this.props.auth.user.listMenu) {
            const menuAccess = this.props.auth.user.listMenu.filter(
                (item) => item.menuParentName === parent && item.menuName === child
            );

            return !R.isNil(index) ? menuAccess[index] : menuAccess;
        }
    };

    componentDidMount() {
        this.getMenuAccess();
    }

    componentDidUpdate() {
        this.getMenuAccess();
    }

    render() {
        let content = (
            <div className="app">
                <Route exact path="/" component={Login}/>
            </div>
        );
        const isTraining = process.env.REACT_APP_ENV === "TRAINING";
        const color = isTraining ? "blue" : "red"
        if (!R.isNil(this.props.auth.user)) {
            content = (
                <div>
                    {/* Multiple Page */}
                    <div className={this.state.appClass}>
                        <div className="app-slide">
                            <div className={`slide-content background-${color}`}>
                                <div className="app-title">
                                    <div
                                        className="col-1"
                                        onClick={() => {
                                            console.log("going home");
                                            // function back to dashboard
                                        }}
                                    >
                                        <h1 className="txt-site txt-white txt-upp txt-18 txt-bold post-center margin-left-10px">
                                            NagaMas
                                        </h1>
                                    </div>
                                    <div className="col-2">
                                        <button className={`btn btn-${color} btn-circle`} onClick={this.opSlide}>
                                            <i className={this.state.appButtonClass}/>
                                        </button>
                                    </div>
                                </div>
                                <div className="slide-list change-scrollbar">
                                    {/* -------------START MENU------------- */}
                                    <div>
                                        <NavLink to={"/home"}>
                                            <div className="app-space">
                                                <input type="checkbox" name="mainmenu" id="home"/>
                                                <label htmlFor="home" className="list">
                                                    <span className="app-space-icon">
                                                        <i className={`fas fa-home fa-lg`} style={{color: "#fff"}}></i>
                                                    </span>
                                                    <span className="app-space-text">HOME</span>
                                                </label>
                                            </div>
                                        </NavLink>
                                        {/*<NavLink to={"/testErrorLog"}>*/}
                                        {/*  <div className="app-space">*/}
                                        {/*    <input type="checkbox" name="mainmenu" id="testErrorLog" />*/}
                                        {/*    <label htmlFor="testErrorLog" className="list">*/}
                                        {/*      <span className="app-space-icon">*/}
                                        {/*        <i className={`fas fa-home fa-lg`} style={{ color: "#fff" }}></i>*/}
                                        {/*      </span>*/}
                                        {/*      <span className="app-space-text">Test Error Log</span>*/}
                                        {/*    </label>*/}
                                        {/*  </div>*/}
                                        {/*</NavLink>*/}
                                    </div>

                                    {this.checkPermissionMenu("DASHBOARD") && (
                                        <div className="app-space">
                                            <input type="checkbox" name="mainmenu" id="dashboard"/>
                                            <label htmlFor="dashboard" className="list">
                                                <span className="app-space-icon">
                                                    <i className={`fas fa-home fa-lg`} style={{color: "#fff"}}></i>
                                                </span>
                                                <span className="app-space-text">DASHBOARD</span>
                                                <span className="app-space-sign"></span>
                                            </label>
                                            <div className="app-space-content">
                                                <div className="app-menu">
                                                    {this.checkPermissionSubMenu("DASHBOARD", "DASHBOARD_CASHIER") &&
                                                        this.createSubMenu("Dashboard Level Cashier", "/dashboard/cashier", "fa fa-lg fa-user")}
                                                    {this.checkPermissionSubMenu("DASHBOARD", "DASHBOARD_SALES") &&
                                                        this.createSubMenu("Dashboard Level Salesman - CS", "/dashboard/sales", "fa fa-lg fa-user")}
                                                    {this.checkPermissionSubMenu("DASHBOARD", "DASHBOARD_KACAB") &&
                                                        this.createSubMenu("Dashboard Level Kepala Cabang Keatas", "/dashboard/kacab", "fa fa-lg fa-user")}
                                                    {this.checkPermissionSubMenu("DASHBOARD", "DASHBOARD_KACAB_ADMIN_CRM") &&
                                                        this.createSubMenu("Dashboard Level Kepala Cabang Keatas dan Admin CRM", "/dashboard/kacab-admin-crm", "fa fa-lg fa-user")}
                                                    {this.checkPermissionSubMenu("DASHBOARD", "DASHBOARD_CRM_COORDINATOR") &&
                                                        this.createSubMenu("Dashboard Level Koordinator", "/dashboard/crm-coordinator", "fa fa-lg fa-user")}
                                                    {this.checkPermissionSubMenu("DASHBOARD", "DASHBOARD_TEAM_LEADER") &&
                                                        this.createSubMenu("Dashboard Level Team Leader", "/dashboard/team-leader", "fa fa-lg fa-user")}
                                                    {this.checkPermissionSubMenu("DASHBOARD", "DASHBOARD_ACCOUNTING") &&
                                                        this.createSubMenu("Dashboard Level Akunting", "/dashboard/accounting", "fa fa-lg fa-user")}
                                                    {this.checkPermissionSubMenu("DASHBOARD", "DASHBOARD_CRM_SALESMAN") &&
                                                        this.createSubMenu("Dashboard Level CRM Salesman - CS", "/dashboard/crm-salesman", "fa fa-lg fa-user")}
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                    
                                    {/* comment for deployment 12/jan/2026 */}
                                    {this.checkPermissionMenu("DASHBOARD_H23") && (
                                        <div className="app-space">
                                            <input type="checkbox" name="mainmenu" id="dashboard_h23"/>
                                            <label htmlFor="dashboard_h23" className="list">
                                                <span className="app-space-icon">
                                                    <i className={`fas fa-home fa-lg`} style={{color: "#fff"}}></i>
                                                </span>
                                                <span className="app-space-text">DASHBOARD H23</span>
                                                <span className="app-space-sign"></span>
                                            </label>
                                            <div className="app-space-content">
                                                <div className="app-menu">
                                                    {this.checkPermissionSubMenu("DASHBOARD_H23", "DASHBOARD_CRM_KACAB_KABENG_ADMIN_CRM") &&
                                                        this.createSubMenu("Dashboard CRM KABENG, KACAB dan Admin CRM", "/dashboard/crm-kabeng-kacab", "fa fa-lg fa-user")}
                                                    {this.checkPermissionSubMenu("DASHBOARD_H23", "DASHBOARD_MEKANIK_SA") &&
                                                        this.createSubMenu("Dashboard Level Mekanik dan SA", "/dashboard/level-mekanik-sa", "fa fa-lg fa-user")}
                                                    {this.checkPermissionSubMenu("DASHBOARD_H23", "DASHBOARD_KABENG_KEATAS") &&
                                                        this.createSubMenu("Dashboard Level Kepala Bengkel Keatas", "/dashboard/level-kabeng-keatas", "fa fa-lg fa-user")}
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    {this.checkPermissionMenu("MASTERDATA") && (
                                        <div className="app-space">
                                            <input type="checkbox" name="mainmenu" id="mainmenu-master-data"/>
                                            <label htmlFor="mainmenu-master-data" className="list">
                                                <span className="app-space-icon">
                                                    <img src={require("../assets/img/icons/master-data.png")} alt=""/>
                                                </span>
                                                <span className="app-space-text">MASTERDATA</span>
                                                <span className="app-space-sign"></span>
                                            </label>
                                            <div className="app-space-content">
                                                <div className="app-menu">
                                                    {this.checkPermissionSubMenu("MASTERDATA", "MASTER_USER") &&
                                                        this.createSubMenu("Master User", "/master/user", "fa fa-lg fa-user")}
                                                    {this.checkPermissionSubMenu("MASTERDATA", "MASTER_SALES") &&
                                                        this.createSubMenu("Master Sales", "/master/sales", "fa fa-lg fa-user")}
                                                    {this.checkPermissionSubMenu("MASTERDATA", "MASTER_CABANG") &&
                                                        this.createSubMenu(
                                                            "Master Cabang",
                                                            "/master/cabang",
                                                            "fa fa-lg fa-user"
                                                        )}
                                                    {this.checkPermissionSubMenu("MASTERDATA", "MASTER_HIRARKI") &&
                                                        this.createSubMenu(
                                                            "Master Hirarki",
                                                            "/master/hirarki",
                                                            "fa fa-lg fa-user"
                                                        )}
                                                    {this.checkPermissionSubMenu("MASTERDATA", "MASTER_SUPPLIER") &&
                                                        this.createSubMenu(
                                                            "Master Supplier & Vendor",
                                                            "/master/supplier-vendor",
                                                            "fa fa-lg fa-user"
                                                        )}
                                                    {this.checkPermissionSubMenu("MASTERDATA", "MASTER_LOGISTIK_MOTOR") &&
                                                        this.createSubMenu(
                                                            "Master Logistik Motor",
                                                            "/master/logistik-motor",
                                                            "fa fa-lg fa-user"
                                                        )}
                                                    {this.checkPermissionSubMenu("MASTERDATA", "MASTER_KSU") &&
                                                        this.createSubMenu(
                                                            "Master Logistik Non Motor (KSU)",
                                                            "/master/ksu",
                                                            "fa fa-lg fa-user"
                                                        )}
                                                    {this.checkPermissionSubMenu("MASTERDATA", "MASTER_LOCATOR") &&
                                                        this.createSubMenu(
                                                            "Master Locator",
                                                            "/master/locator",
                                                            "fa fa-lg fa-user"
                                                        )}
                                                    {this.checkPermissionSubMenu("MASTERDATA", "MASTER_PARAMETER") &&
                                                        this.createSubMenu(
                                                            "Master Parameter",
                                                            "/master/parameter",
                                                            "fa fa-lg fa-user"
                                                        )}
                                                    {this.checkPermissionSubMenu("MASTERDATA", "MASTER_KAS") &&
                                                        this.createSubMenu("Master Kas", "/master/kas", "fa fa-lg fa-user")}
                                                    {this.checkPermissionSubMenu("MASTERDATA", "SETTING_HAK_AKSES") &&
                                                        this.createSubMenu(
                                                            "Setting Hak Akses",
                                                            "/master/setting-hak-akses",
                                                            "fa fa-lg fa-user"
                                                        )}
                                                    {this.checkPermissionSubMenu("MASTERDATA", "MASTER_SAMSAT") &&
                                                        this.createSubMenu(
                                                            "Master Samsat",
                                                            "/master/samsat",
                                                            "fa fa-lg fa-user"
                                                        )}
                                                    {this.checkPermissionSubMenu("MASTERDATA", "MASTER_BANK") &&
                                                        this.createSubMenu("Master Bank", "/master/bank", "fa fa-lg fa-user")}
                                                    {this.checkPermissionSubMenu("MASTERDATA", "MASTER_PART") &&
                                                        this.createSubMenu("Master Part", "/master/part", "fa fa-lg fa-user")}
                                                    {this.checkPermissionSubMenu("MASTERDATA", "MASTER_PROMO") &&
                                                        this.createSubMenu("Master Promo", "/master/promo", "fa fa-lg fa-user")}
                                                    {this.checkPermissionSubMenu("MASTERDATA", "MASTER_VOUCHER") &&
                                                        this.createSubMenu("Master Voucher", "/master/voucher", "fa fa-lg fa-user")}
                                                    {this.checkPermissionSubMenu("MASTERDATA", "MASTER_LEASING") &&
                                                        this.createSubMenu(
                                                            "Master Leasing",
                                                            "/master/leasing",
                                                            "fa fa-lg fa-user"
                                                        )}
                                                    {this.checkPermissionSubMenu("MASTERDATA", "MASTER_APPROVAL") &&
                                                        this.createSubMenu(
                                                            "Master Approval",
                                                            "/master/approval",
                                                            "fa fa-lg fa-user"
                                                        )}
                                                    {this.checkPermissionSubMenu("MASTERDATA", "MASTER_UNIT_PRICE") &&
                                                        this.createSubMenu(
                                                            "Master Unit Price",
                                                            "/master/units",
                                                            "fa fa-lg fa-user"
                                                        )}
                                                    {this.checkPermissionSubMenu("MASTERDATA", "MASTER_PACKAGE") &&
                                                        this.createSubMenu(
                                                            "Master Package",
                                                            "/master/package",
                                                            "fa fa-lg fa-user"
                                                        )}
                                                    {this.checkPermissionSubMenu("MASTERDATA", "MASTER_BBN") &&
                                                        this.createSubMenu(
                                                            "Master Tabel BBN",
                                                            "/master/bbn",
                                                            "fa fa-lg fa-user"
                                                        )}
                                                    {this.checkPermissionSubMenu("MASTERDATA", "MASTER_SERVICE") &&
                                                        this.createSubMenu(
                                                            "Master Jasa/Job",
                                                            "/master/service",
                                                            "fa fa-lg fa-user"
                                                    )}
                                                    {this.checkPermissionSubMenu("MASTERDATA", "MASTER_COA") &&
                                                        this.createSubMenu(
                                                            "Master COA",
                                                            "/master/coa",
                                                             "fa fa-lg fa-user"
                                                        )}

                                                    {this.checkPermissionSubMenu("MASTERDATA", "MASTER_SOPIR") &&
                                                        this.createSubMenu(
                                                            "Master Sopir",
                                                            "/master/sopir",
                                                            "fa fa-lg fa-user"
                                                        )}
                                                    {this.checkPermissionSubMenu("MASTERDATA", "MASTER_MECHANIC") &&
                                                        this.createSubMenu(
                                                            "Master Mekanik",
                                                            "/master/mekanik",
                                                            "fa fa-lg fa-user"
                                                        )}

                                                    {this.checkPermissionSubMenu("MASTERDATA", "MASTER_BOOKING") &&
                                                        this.createSubMenu(
                                                            "Master Booking",
                                                            "/master/booking",
                                                             "fa fa-lg fa-user"
                                                        )}

                                                    {this.checkPermissionSubMenu("MASTERDATA", "MASTER_PART_PRICE") &&
                                                        this.createSubMenu(
                                                            "Master Harga Part",
                                                            "/master/part-price",
                                                            "fa fa-lg fa-user"
                                                        )}
                                                        
                                                    {this.checkPermissionSubMenu("MASTERDATA", "MASTER_ACUAN_STOCK") &&
                                                        this.createSubMenu(
                                                            "Master Acuan Stock",
                                                            "/master/acuan-stock",
                                                            "fa fa-lg fa-user"
                                                        )}
                                                    {this.checkPermissionSubMenu("MASTERDATA", "MASTER_HARGA_JASA") &&
                                                        this.createSubMenu(
                                                            "Master Harga Jasa",
                                                            "/master/harga-jasa",
                                                            "fa fa-lg fa-user"
                                                        )}

                                                     {this.checkPermissionSubMenu("MASTERDATA", "MASTER_PROMO_H23") &&
                                                        this.createSubMenu(
                                                            "Master Promo H23",
                                                            "/master/promo-h23",
                                                            "fa fa-lg fa-user"
                                                        )}

                                                    {this.checkPermissionSubMenu("MASTERDATA", "MASTER_PACKAGE_H23") &&
                                                        this.createSubMenu(
                                                            "Master Package H23",
                                                            "/master/package-h23",
                                                            "fa fa-lg fa-user"
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    {this.checkPermissionMenu("H1") && (
                                        <div className="app-space">
                                            <input type="checkbox" name="mainmenu" id="mainmenu-h1"/>
                                            <label htmlFor="mainmenu-h1" className="list">
                                                <span className="app-space-icon">
                                                    <img src={require("../assets/img/icons/master-data.png")} alt=""/>
                                                </span>
                                                <span className="app-space-text">H1</span>
                                                <span className="app-space-sign"></span>
                                            </label>
                                            <div className="app-space-content">
                                                <div className="app-menu">
                                                    {this.checkPermissionSubMenu("H1", "RECEIVING_UNIT") &&
                                                        this.createSubMenu(
                                                            "Receiving Unit",
                                                            "/h1/receiving/receiving-unit",
                                                            "fa fa-lg fa-user"
                                                        )
                                                    }

                                                    {this.checkPermissionSubMenu("H1", "RECEIVING_KSU") &&
                                                        this.createSubMenu(
                                                            "Receiving KSU",
                                                            "/h1/receiving/receiving-ksu",
                                                            "fa fa-lg fa-user"
                                                        )
                                                    }

                                                    {this.checkPermissionSubMenu("H1", "RECEIVING_ITEM") &&
                                                        this.createSubMenu(
                                                            "Receiving Item",
                                                            "/h1/receiving/receiving-item",
                                                            "fa fa-lg fa-user"
                                                        )
                                                    }

                                                    {this.checkPermissionSubMenu("H1", "INVENTORY_STOCK") &&
                                                        this.createSubMenu(
                                                            "Inventory",
                                                            "/h1/inventory/inventory-stock",
                                                            "fa fa-lg fa-user"
                                                        )
                                                    }

                                                    {this.checkPermissionSubMenu("H1", "MUTASI_BARANG") &&
                                                        this.createSubMenu(
                                                            "Mutasi Barang",
                                                            "/h1/unit-movement/mutasi-barang",
                                                            "fa fa-lg fa-user"
                                                        )
                                                    }

                                                    {this.checkPermissionSubMenu("H1", "STOCK_OPNAME") &&
                                                        this.createSubMenu(
                                                            "Stock Opname",
                                                            "/h1/stock-opname",
                                                            "fa fa-lg fa-user"
                                                        )
                                                    }

                                                    {this.checkPermissionSubMenu("H1", "PO_UNIT") &&
                                                        this.createSubMenu(
                                                            "PO Unit",
                                                            "/h1/procurement/po-unit",
                                                            "fa fa-lg fa-user"
                                                        )
                                                    }

                                                    {this.checkPermissionSubMenu("H1", "INDENT_UNIT") &&
                                                        this.createSubMenu(
                                                            "Indent Unit",
                                                            "/h1/sales-order/indent-unit",
                                                            "fa fa-lg fa-user"
                                                        )
                                                    }

                                                    {this.checkPermissionSubMenu("H1", "FAKTUR_JUAL") &&
                                                        this.createSubMenu(
                                                            "Faktur Jual",
                                                            "/h1/sales-order/faktur-jual",
                                                            "fa fa-lg fa-user"
                                                        )
                                                    }

                                                    {this.checkPermissionSubMenu("H1", "PDI") &&
                                                        this.createSubMenu(
                                                            "PDI",
                                                            "/h1/delivery/pdi",
                                                            "fa fa-lg fa-user"
                                                        )
                                                    }

                                                    {
                                                        this.checkPermissionSubMenu("H1", "EKSPEDISI") &&
                                                        this.createSubMenu(
                                                            "Ekspedisi",
                                                            "/h1/delivery/ekspedisi",
                                                            "fa fa-lg fa-user"
                                                        )
                                                    }

                                                    {this.checkPermissionSubMenu("H1", "DELIVERY_H1") &&
                                                        this.createSubMenu(
                                                            "Delivery H1",
                                                            "/h1/delivery/delivery-h1",
                                                            "fa fa-lg fa-user"
                                                        )
                                                    }

                                                    {this.checkPermissionSubMenu("H1", "CLAIM_C1") &&
                                                        this.createSubMenu(
                                                            "Claim C1",
                                                            "/h1/claim-c1",
                                                            "fa fa-lg fa-user"
                                                        )
                                                    }

                                                    {this.checkPermissionSubMenu("H1", "PROSES_SSU") &&
                                                        this.createSubMenu(
                                                            "Proses SSU",
                                                            "/h1/proses-ssu",
                                                            "fa fa-lg fa-user"
                                                        )
                                                    }

                                                    {this.checkPermissionSubMenu("H1", "PROSES_SAMSAT") &&
                                                        this.createSubMenu(
                                                            "Proses SAMSAT",
                                                            "/h1/proses-samsat",
                                                            "fa fa-lg fa-user"
                                                        )
                                                    }

                                                    {this.checkPermissionSubMenu("H1", "PENYERAHAN_BBN") &&
                                                        this.createSubMenu(
                                                            "Penyerahan BBN",
                                                            "/h1/penyerahan-bbn",
                                                            "fa fa-lg fa-user"
                                                        )
                                                    }

                                                    {this.checkPermissionSubMenu("H1", "CDB_PROFILE") &&
                                                        this.createSubMenu(
                                                            "CDB - Customer Profile",
                                                            "/h1/cdb-profile",
                                                            "fa fa-lg fa-user"
                                                        )
                                                    }
                                                    {this.checkPermissionSubMenu("H1", "CRM_ASSIGN") &&
                                                        this.createSubMenu(
                                                            "CRM Assign Prospek",
                                                            "/h1/crm/assign-prospek",
                                                            "fa fa-lg fa-user"
                                                        )}

                                                    {this.checkPermissionSubMenu("H1", "CRM_FOLLOW_UP") &&
                                                        this.createSubMenu(
                                                            "CRM Follow Up Prospek",
                                                            "/h1/crm/follow-up-prospek",
                                                            "fa fa-lg fa-user"
                                                        )
                                                    }
                                                    {this.checkPermissionSubMenu("H1", "CRM_CDB") &&
                                                        this.createSubMenu(
                                                            "CRM Manajemen CDB",
                                                            "/h1/crm/manajemen-cdb",
                                                            "fa fa-lg fa-user"
                                                        )
                                                    }

                                                    {this.checkPermissionSubMenu("H1", "MANAGEMENT_NOTIFICATION") &&
                                                        this.createSubMenu(
                                                            "Management Notification",
                                                            "/h1/management-notification",
                                                            "fa fa-lg fa-user"
                                                        )
                                                    }

                                                    {this.checkPermissionSubMenu("H1", "MANAGEMENT_APPROVAL") &&
                                                        this.createSubMenu(
                                                            "Management Approval",
                                                            "/h1/management-approval",
                                                            "fa fa-lg fa-user"
                                                        )
                                                    }
                                                    {this.checkPermissionSubMenu("H1", "MANAGEMENT_NRFS") &&
                                                        this.createSubMenu(
                                                            "Management NRFS",
                                                            "/h1/management-nrfs",
                                                            "fa fa-lg fa-user"
                                                        )
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    {this.checkPermissionMenu("H23") && (
                                        <div className="app-space">
                                            <input type="checkbox" name="mainmenu" id="mainmenu-h3-module"/>
                                            <label htmlFor="mainmenu-h3-module" className="list">
                                                <span className="app-space-icon">
                                                    <img src={require("../assets/img/icons/master-data.png")} alt=""/>
                                                </span>
                                                <span className="app-space-text">H23</span>
                                                <span className="app-space-sign"></span>
                                            </label>
                                            <div className="app-space-content">
                                                <div className="app-menu">
                                                    {this.checkPermissionSubMenu("H23", "MUTASI_PART") &&
                                                        this.createSubMenu(
                                                            "Mutasi Part",
                                                            "/h23/mutasi-part",
                                                            "fa fa-lg fa-user"
                                                        )}
                                                </div>
                                            </div>
                                            <div className="app-space-content">
                                                <div className="app-menu">
                                                    {this.checkPermissionSubMenu("H23", "RECEIVING_PART") &&
                                                        this.createSubMenu(
                                                            "Receiving Part",
                                                            "/h23/receiving-part",
                                                            "fa fa-lg fa-user"
                                                        )}
                                                </div>
                                            </div>
                                            <div className="app-space-content">
                                                <div className="app-menu">
                                                    {this.checkPermissionSubMenu("H23", "MANAGEMENT_MECHANIC") &&
                                                        this.createSubMenu(
                                                            "Management Mekanik",
                                                            "/h23/management-mekanik",
                                                            "fa fa-lg fa-user"
                                                        )}
                                                </div>
                                            </div>
                                            <div className="app-space-content">
                                                <div className="app-menu">
                                                    {this.checkPermissionSubMenu("H23", "MANAGEMENT_BOOKING") &&
                                                        this.createSubMenu(
                                                            "Management Booking",
                                                            "/h23/management-booking",
                                                            "fa fa-lg fa-user"
                                                        )}
                                                </div>
                                            </div>
                                            {/* <div className="app-space-content">
                                                <div className="app-menu">
                                                    {this.checkPermissionSubMenu("H23", "CRM_FOLLOW_UP_H23") &&
                                                        this.createSubMenu(
                                                            "Followup Prospek H23",
                                                            "/h23/crm/follow-up-prospek",
                                                            "fa fa-lg fa-user"
                                                        )}
                                                </div>
                                            </div> */}
                                            <div className="app-space-content">
                                                <div className="app-menu">
                                                    {this.checkPermissionSubMenu("H23", "MANAGEMENT_CLAIM") &&
                                                        this.createSubMenu(
                                                            "Manajemen Claim",
                                                            "/h23/management-claim",
                                                            "fa fa-lg fa-user"
                                                        )}
                                                </div>
                                            </div>
                                            <div className="app-space-content">
                                                <div className="app-menu">
                                                    {this.checkPermissionSubMenu("H23", "INVENTORY_PART") &&
                                                        this.createSubMenu(
                                                            "Inventory Part",
                                                            "/h23/inventory-part",
                                                            "fa fa-lg fa-user"
                                                        )}
                                                </div>
                                            </div>
                                            <div className="app-space-content">
                                                <div className="app-menu">
                                                    {this.checkPermissionSubMenu("H23", "FAKTUR_JUAL_BENGKEL") &&
                                                        this.createSubMenu(
                                                            "Faktur Jual Bengkel",
                                                            "/h23/faktur-jual-bengkel",
                                                            "fa fa-lg fa-user"
                                                        )}
                                                </div>
                                            </div>
                                            <div className="app-space-content">
                                                <div className="app-menu">
                                                    {this.checkPermissionSubMenu("H23", "PO_PART") &&
                                                        this.createSubMenu(
                                                            "Po Part",
                                                            "/h23/po-part",
                                                            "fa fa-lg fa-user"
                                                        )}
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    {this.checkPermissionMenu("ACCOUNTING") && (
                                        <div className="app-space">
                                            <input type="checkbox" name="mainmenu" id="mainmenu-accounting"/>
                                            <label htmlFor="mainmenu-accounting" className="list">
                                                <span className="app-space-icon">
                                                    <img src={require("../assets/img/icons/master-data.png")} alt=""/>
                                                </span>
                                                <span className="app-space-text">ACCOUNTING</span>
                                                <span className="app-space-sign"></span>
                                            </label>
                                            <div className="app-space-content">
                                                <div className="app-menu">
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    {this.checkPermissionMenu("FINANCE") && (
                                        <div className="app-space">
                                            <input type="checkbox" name="mainmenu" id="mainmenu-accounting"/>
                                            <label htmlFor="mainmenu-accounting" className="list">
                                                <span className="app-space-icon">
                                                    <img src={require("../assets/img/icons/master-data.png")} alt=""/>
                                                </span>
                                                <span className="app-space-text">FINANCE</span>
                                                <span className="app-space-sign"></span>
                                            </label>
                                            <div className="app-space-content">
                                                <div className="app-menu">
                                                    {this.checkPermissionSubMenu("FINANCE", "TRANSAKSI_BANK") &&
                                                        this.createSubMenu(
                                                            "Transaksi Bank",
                                                            "/finance/payment/transaksi-bank",
                                                            "fa fa-lg fa-user"
                                                        )}
                                                    {this.checkPermissionSubMenu("FINANCE", "TRANSAKSI_CASH") &&
                                                        this.createSubMenu(
                                                            "Transaksi Cash",
                                                            "/finance/payment/transaksi-cash",
                                                            "fa fa-lg fa-user"
                                                        )}
                                                    {this.checkPermissionSubMenu("FINANCE", "PENAGIHAN_LEASING") &&
                                                        this.createSubMenu(
                                                            "Penagihan Leasing",
                                                            "/finance/penagihan-leasing",
                                                            "fa fa-lg fa-user"
                                                        )}
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    {this.checkPermissionMenu("#MASTER") && (
                                        <div className="app-space">
                                            <input type="checkbox" name="mainmenu" id="mainmenu-master-data"/>
                                            <label htmlFor="mainmenu-master-data" className="list">
                                                <span className="app-space-icon">
                                                    <img src={require("../assets/img/icons/master-data.png")} alt=""/>
                                                </span>
                                                <span className="app-space-text">MASTERDATA</span>
                                                <span className="app-space-sign"></span>
                                            </label>
                                            <div className="app-space-content">
                                                <div className="app-menu">
                                                    {this.checkPermissionSubMenu("MASTER", "MASTER-001") &&
                                                        this.createSubMenu(
                                                            "User Management",
                                                            "/master/user-matrix",
                                                            "fa fa-lg fa-user"
                                                        )}
                                                    {this.checkPermissionSubMenu("MASTER", "MASTER-002") &&
                                                        this.createSubMenu(
                                                            "Bank Management",
                                                            "/master/bank-matrix",
                                                            "fa fa-lg fa-user"
                                                        )}
                                                    {this.checkPermissionSubMenu("MASTER", "MASTER-003") &&
                                                        this.createSubMenu(
                                                            "Master Jasa",
                                                            "/master/jasa-matrix",
                                                            "fa fa-lg fa-user"
                                                        )}
                                                    {this.checkPermissionSubMenu("MASTER", "MASTER-004") &&
                                                        this.createSubMenu(
                                                            "Master Warehouse",
                                                            "/master/warehouse-matrix",
                                                            "fa fa-lg fa-user"
                                                        )}
                                                    {this.checkPermissionSubMenu("MASTER", "MASTER-005") &&
                                                        this.createSubMenu(
                                                            "Master Varian",
                                                            "/master/varian-matrix",
                                                            "fa fa-lg fa-user"
                                                        )}
                                                    {this.checkPermissionSubMenu("MASTER", "MASTER-006") &&
                                                        this.createSubMenu(
                                                            "Master Pit",
                                                            "/master/pit-matrix",
                                                            "fa fa-lg fa-user"
                                                        )}
                                                    {this.checkPermissionSubMenu("MASTER", "MASTER-007") &&
                                                        this.createSubMenu(
                                                            "Master Voucher",
                                                            "/master/voucher-matrix",
                                                            "fa fa-lg fa-user"
                                                        )}
                                                    {this.checkPermissionSubMenu("MASTER", "MASTER-008") &&
                                                        this.createSubMenu(
                                                            "Master Supplier",
                                                            "/master/supplier-matrix",
                                                            "fa fa-lg fa-user"
                                                        )}
                                                    {this.checkPermissionSubMenu("MASTER", "MASTER-009") &&
                                                        this.createSubMenu(
                                                            "Master Unit",
                                                            "/master/units-matrix",
                                                            "fa fa-lg fa-user"
                                                        )}
                                                    {this.checkPermissionSubMenu("MASTER", "MASTER-010") &&
                                                        this.createSubMenu(
                                                            "Master Parameter",
                                                            "/master/parameter-matrix",
                                                            "fa fa-lg fa-user"
                                                        )}
                                                    {this.checkPermissionSubMenu("MASTER", "MASTER-011") &&
                                                        this.createSubMenu(
                                                            "Master Notification",
                                                            "/master/notifikasi-matrix",
                                                            "fa fa-lg fa-user"
                                                        )}
                                                    {this.checkPermissionSubMenu("MASTER", "MASTER-012") &&
                                                        this.createSubMenu(
                                                            "Master Wilayah",
                                                            "/master/wilayah-matrix",
                                                            "fa fa-lg fa-user"
                                                        )}
                                                </div>
                                                <div className="app-menu">
                                                    {this.checkPermissionSubMenu("MASTER", "MASTER-013") &&
                                                        this.createSubMenu(
                                                            "Master Cabang",
                                                            "/master/cabang-matrix",
                                                            "fa fa-lg fa-user"
                                                        )}
                                                    {this.checkPermissionSubMenu("MASTER", "MASTER-014") &&
                                                        this.createSubMenu(
                                                            "Master Items",
                                                            "/master/item-matrix",
                                                            "fa fa-lg fa-user"
                                                        )}
                                                    {this.checkPermissionSubMenu("MASTER", "MASTER-015") &&
                                                        this.createSubMenu(
                                                            "Master Parts",
                                                            "/master/part-matrix",
                                                            "fa fa-lg fa-user"
                                                        )}
                                                    {this.checkPermissionSubMenu("MASTER", "MASTER-016") &&
                                                        this.createSubMenu(
                                                            "Master KSU",
                                                            "/master/mksu-matrix",
                                                            "fa fa-lg fa-user"
                                                        )}
                                                    {this.checkPermissionSubMenu("MASTER", "MASTER-017") &&
                                                        this.createSubMenu(
                                                            "Master Role Access",
                                                            "/master/access-matrix",
                                                            "fa fa-lg fa-user"
                                                        )}
                                                    {this.checkPermissionSubMenu("MASTER", "MASTER-018") &&
                                                        this.createSubMenu(
                                                            "Master Leasing",
                                                            "/master/leasing-matrix",
                                                            "fa fa-lg fa-user"
                                                        )}
                                                    {this.checkPermissionSubMenu("MASTER", "MASTER-019") &&
                                                        this.createSubMenu(
                                                            "Master Pricelist",
                                                            "/master/pricelist-matrix",
                                                            "fa fa-lg fa-user"
                                                        )}
                                                    {this.checkPermissionSubMenu("MASTER", "MASTER-020") &&
                                                        this.createSubMenu(
                                                            "Master Discount",
                                                            "/master/discount-matrix",
                                                            "fa fa-lg fa-user"
                                                        )}
                                                    {this.checkPermissionSubMenu("MASTER", "MASTER-021") &&
                                                        this.createSubMenu(
                                                            "Master Package",
                                                            "/master/package-matrix",
                                                            "fa fa-lg fa-user"
                                                        )}
                                                    {this.checkPermissionSubMenu("MASTER", "MASTER-022") &&
                                                        this.createSubMenu(
                                                            "Master Poin",
                                                            "/master/poin-matrix",
                                                            "fa fa-lg fa-user"
                                                        )}
                                                    {this.checkPermissionSubMenu("MASTER", "MASTER-023") &&
                                                        this.createSubMenu(
                                                            "Samsat",
                                                            "/master/samsat-matrix",
                                                            "fa fa-lg fa-user"
                                                        )}
                                                    {this.checkPermissionSubMenu("MASTER", "MASTER-024") &&
                                                        this.createSubMenu(
                                                            "Promotion",
                                                            "/master/promo-matrix",
                                                            "fa fa-lg fa-user"
                                                        )}
                                                    {this.checkPermissionSubMenu("MASTER", "MASTER-025") &&
                                                        this.createSubMenu(
                                                            "Batery EV",
                                                            "/master/batery-matrix",
                                                            "fa fa-lg fa-user"
                                                        )}
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    {this.checkPermissionMenu("#H1MODULE") && (
                                        <div className="app-space">
                                            <input type="checkbox" name="mainmenu" id="mainmenu-h1-module"/>
                                            <label htmlFor="mainmenu-h1-module" className="list">
                                                <span className="app-space-icon">
                                                    <i className={`fa fa-warehouse`} style={{color: "#fff"}}></i>
                                                </span>
                                                <span className="app-space-text">H1 Module</span>
                                                <span className="app-space-sign"></span>
                                            </label>
                                            <div className="app-space-content">
                                                <div className="app-menu">
                                                    {this.checkPermissionSubMenu("H1MODULE", "H1MODULE-001") &&
                                                        this.createSubMenu("Report", "/h1Module/report-matrix", "fa fa-truck")}
                                                    {this.checkPermissionSubMenu("H1MODULE", "H1MODULE-002") &&
                                                        this.createSubMenu(
                                                            "Claim C1",
                                                            "/h1Module/claimC1-matrix",
                                                            "fa fa-truck"
                                                        )}
                                                    {this.checkPermissionSubMenu("H1MODULE", "H1MODULE-003") &&
                                                        this.createSubMenu(
                                                            "Receiving Units",
                                                            "/h1Module/receivingUnit-matrix",
                                                            "fa fa-truck"
                                                        )}
                                                    {this.checkPermissionSubMenu("H1MODULE", "H1MODULE-004") &&
                                                        this.createSubMenu(
                                                            "Delivery",
                                                            "/h1Module/delivery-matrix",
                                                            "fa fa-truck"
                                                        )}
                                                    {this.checkPermissionSubMenu("H1MODULE", "H1MODULE-005") &&
                                                        this.createSubMenu(
                                                            "Inventory",
                                                            "/h1Module/inventory-matrix",
                                                            "fa fa-truck"
                                                        )}
                                                    {this.checkPermissionSubMenu("H1MODULE", "H1MODULE-006") &&
                                                        this.createSubMenu(
                                                            "Payment",
                                                            "/h1Module/payment-matrix",
                                                            "fa fa-truck"
                                                        )}
                                                    {this.checkPermissionSubMenu("H1MODULE", "H1MODULE-007") &&
                                                        this.createSubMenu(
                                                            "Unit Movement",
                                                            "/h1Module/unitMovement-matrix",
                                                            "fa fa-truck"
                                                        )}
                                                    {this.checkPermissionSubMenu("H1MODULE", "H1MODULE-008") &&
                                                        this.createSubMenu(
                                                            "Stock Opname",
                                                            "/h1Module/stockOpname-matrix",
                                                            "fa fa-truck"
                                                        )}
                                                    {this.checkPermissionSubMenu("H1MODULE", "H1MODULE-009") &&
                                                        this.createSubMenu(
                                                            "Purchase Order",
                                                            "/h1Module/order-matrix",
                                                            "fa fa-truck"
                                                        )}
                                                    {this.checkPermissionSubMenu("H1MODULE", "H1MODULE-010") &&
                                                        this.createSubMenu(
                                                            "Misc IN OUT",
                                                            "/h1Module/miscInOut-matrix",
                                                            "fa solid fa-truck"
                                                        )}
                                                    {this.checkPermissionSubMenu("H1MODULE", "H1MODULE-011") &&
                                                        this.createSubMenu(
                                                            "Receiving KSU",
                                                            "/h1Module/ksu-matrix",
                                                            "fa solid fa-truck"
                                                        )}
                                                    {this.checkPermissionSubMenu("H1MODULE", "H1MODULE-012") &&
                                                        this.createSubMenu(
                                                            "Purchase Return",
                                                            "/h1Module/return-matrix",
                                                            "fa fa-truck"
                                                        )}
                                                    {this.checkPermissionSubMenu("H1MODULE", "H1MODULE-013") &&
                                                        this.createSubMenu(
                                                            "Customer Data",
                                                            "/h1Module/data-matrix",
                                                            "fa fa-truck"
                                                        )}
                                                    {this.checkPermissionSubMenu("H1MODULE", "H1MODULE-014") &&
                                                        this.createSubMenu(
                                                            "FU Prospek",
                                                            "/h1Module/prospek-matrix",
                                                            "fa fa-truck"
                                                        )}
                                                    {this.checkPermissionSubMenu("H1MODULE", "H1MODULE-015") &&
                                                        this.createSubMenu("Kas", "/h1Module/kas-matrix", "fa fa-truck")}
                                                    {this.checkPermissionSubMenu("H1MODULE", "H1MODULE-016") &&
                                                        this.createSubMenu("FSB", "/h1Module/fandb-matrix", "fa fa-truck")}
                                                </div>
                                                {/* <div className='app-menu'>
                      {this.checkPermissionSubMenu('H1MODULE', 'MASTER-022') && this.createSubMenu('Cabang', '/master/cabang-matrix', 'fa fa-lg fa-user')}
                    </div> */}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>

                        <div className="app-main">
                            <div className="app-panel">
                                <div className="panel-content">
                                    <div className="col-1">
                                        {/* <div>
                  <SearchPopup />
                </div> */}
                                        <div
                                            className="margin-5px"
                                            style={{
                                                display: "flex",
                                                flexDirection: "row",
                                            }}
                                        >
                                            <img
                                                src={require("../assets/img/logo-nagamas.png")}
                                                width={30}
                                                height={30}
                                                // alt=""
                                                style={{marginRight: 10}}
                                            />
                                            <div style={{fontSize: 22}}>
                                                {this.checkPermissionSubMenu("MASTER", "MASTER-022") &&
                                                    this.createHomeMenu("NAGAMAS", "/home", "")}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-2 content-right">
                                        {/* <div className="panel-button app-desktop">
                  <CreatePopup />
                </div> */}
                                        {/* <div className="panel-button app-desktop" style={{marginLeft: "10px"}}>
                  <ChatPopup />
                </div> */}
                                        <div className="panel-button app-desktop" style={{marginLeft: "10px"}}>
                                            <NotifPopup/>
                                        </div>
                                        <div className="panel-button">
                                            <ProfilePopup/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="app-place">
                                {/* MASTER DATA */}
                                <Route exact path="/master/user" component={()=>{
                                    const menuAccess = this.getMenuAccessForUser("MASTERDATA", "MASTER_USER", 0);
                                    return <MasterUser menuAccess={menuAccess}/>
                                }}/>
                                <Route exact path="/master/cabang" component={MasterCabang}/>
                                <Route
                                    exact
                                    path="/master/hirarki"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser("MASTERDATA", "MASTER_HIRARKI", 0);
                                        return <MasterHirarki menuAccess={menuAccess}/>;
                                    }}
                                />
                                <Route exact path="/master/supplier-vendor" component={MasterSuppliers}/>
                                <Route
                                    exact
                                    path="/master/logistik-motor"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser(
                                            "MASTERDATA",
                                            "MASTER_LOGISTIK_MOTOR",
                                            0
                                        );
                                        return <MasterLogistikMotor menuAccess={menuAccess}/>;
                                    }}
                                />
                                <Route
                                    exact
                                    path="/master/ksu"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser("MASTERDATA", "MASTER_KSU", 0);
                                        return <MasterLogistikNonMotor menuAccess={menuAccess}/>;
                                    }}
                                />
                                <Route
                                    exact
                                    path="/master/locator"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser("MASTERDATA", "MASTER_LOCATOR", 0);
                                        return <MasterLocator menuAccess={menuAccess}/>;
                                    }}
                                />
                                <Route
                                    exact
                                    path="/master/samsat"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser("MASTERDATA", "MASTER_SAMSAT");
                                        return <MasterSamsat menuAccess={menuAccess}/>;
                                    }}
                                />
                                <Route
                                    exact
                                    path="/master/approval"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser(
                                            "MASTERDATA",
                                            "MASTER_APPROVAL",
                                            0
                                        );
                                        return <MasterApproval menuAccess={menuAccess}/>;
                                    }}
                                />
                                <Route exact path="/master/parameter" component={MasterParameter}/>
                                <Route exact path="/master/kas" component={MasterKas}/>
                                <Route exact path="/master/setting-hak-akses" component={AccessMenuSetting}/>

                                <Route
                                    exact
                                    path="/master/package"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser("MASTERDATA", "MASTER_PACKAGE");
                                        return <MasterPackage menuAccess={menuAccess}/>;
                                    }}
                                />

                                <Route
                                    exact
                                    path="/master/coa"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser("MASTERDATA", "MASTER_COA");
                                        return <MasterCOA menuAccess={menuAccess}/>;
                                    }}
                                />

                                <Route
                                    exact
                                    path="/master/bbn"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser("MASTERDATA", "MASTER_BBN");
                                        return <MasterBBN menuAccess={menuAccess}/>;
                                    }}
                                />
                                
                                <Route
                                    exact
                                    path="/master/sopir"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser("MASTERDATA", "MASTER_SOPIR");
                                        return <MasterSopir menuAccess={menuAccess}/>;
                                    }}
                                />
                                <Route
                                    exact
                                    path="/master/mekanik"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser("MASTERDATA", "MASTER_MECHANIC");
                                        return <MasterMekanik menuAccess={menuAccess}/>;
                                    }}
                                />

                                <Route
                                    exact
                                    path="/master/service"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser("MASTERDATA", "MASTER_SERVICE", 0);
                                        return <MasterService menuAccess={menuAccess} />;
                                    }}
                                />

                                <Route
                                    exact
                                    path="/master/booking"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser("MASTERDATA", "MASTER_BOOKING");
                                        return <MasterBooking menuAccess={menuAccess} />;
                                    }}
                                />

                                <Route
                                    exact
                                    path="/master/part-price"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser("MASTERDATA", "MASTER_PART_PRICE");
                                        return <MasterPartPrice menuAccess={menuAccess} />;
                                    }}
                                />

                                <Route
                                    exact
                                    path="/master/acuan-stock"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser("MASTERDATA", "MASTER_ACUAN_STOCK", 0);
                                        return <MasterAcuanStock menuAccess={menuAccess} />;
                                    }}
                                />
                                <Route
                                    exact
                                    path="/master/harga-jasa"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser("MASTERDATA", "MASTER_HARGA_JASA");
                                        return <MasterHargaJasa menuAccess={menuAccess} />;
                                    }}
                                />

                                <Route
                                    exact
                                    path="/master/promo-h23"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser("MASTERDATA", "MASTER_PROMO_H23");
                                        return <MasterPromoH2 menuAccess={menuAccess} />;
                                    }}
                                />

                                <Route
                                    exact
                                    path="/master/package-h23"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser("MASTERDATA", "MASTER_PACKAGE_H23");
                                        return <MasterPackageH2 menuAccess={menuAccess}/>;
                                    }}
                                />

                                <Route
                                    exact
                                    path="/h1/receiving/receiving-unit"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser("H1", "RECEIVING_UNIT");
                                        return <ReceivingUnit menuAccess={menuAccess}/>;
                                    }}
                                />

                                <Route
                                    exact
                                    path="/h1/sales-order/indent-unit"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser("H1", "INDENT_UNIT");
                                        return <IndentUnit menuAccess={menuAccess}/>;
                                    }}
                                />

                                <Route
                                    exact
                                    path="/h1/delivery/delivery-h1"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser("H1", "DELIVERY_H1");
                                        return <DeliveryConfirmed menuAccess={menuAccess}/>;
                                    }}
                                />

                                <Route
                                    exact
                                    path="/h1/delivery/pdi"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser("H1", "PDI");
                                        return <Pdi menuAccess={menuAccess}/>;
                                    }}
                                />

                                <Route
                                    exact
                                    path="/h1/delivery/ekspedisi"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser("H1", "EKSPEDISI");
                                        return <Ekspedisi menuAccess={menuAccess}/>;
                                    }}
                                />

                                <Route
                                    exact
                                    path="/h1/receiving/receiving-ksu"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser("H1", "RECEIVING_KSU");
                                        return <ReceivingKSU menuAccess={menuAccess}/>;
                                    }}
                                />

                                {/* <Route
                                    exact
                                    path="/h1/receiving/receiving-item"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser("H1", "RECEIVING_ITEM");
                                        return <PenerimaanItem menuAccess={menuAccess}/>;
                                    }}
                                /> */}

                                <Route
                                    exact
                                    path="/h1/receiving/receiving-item"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser("H1", "RECEIVING_ITEM");
                                        return <ReceivingItem menuAccess={menuAccess} />;
                                    }}
                                />

                                <Route
                                    exact
                                    path="/h1/inventory/inventory-stock"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser("H1", "INVENTORY_STOCK");
                                        return <InventoryStock menuAccess={menuAccess}/>;
                                    }}
                                />

                                <Route
                                    exact
                                    path="/h1/unit-movement/mutasi-barang"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser("H1", "MUTASI_BARANG");
                                        return <MutasiBarang menuAccess={menuAccess}/>;
                                    }}
                                />

                                <Route
                                    exact
                                    path="/h1/procurement/po-unit"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser("H1", "PO_UNIT");
                                        return <POUnit menuAccess={menuAccess}/>;
                                    }}
                                />

                                <Route
                                    exact
                                    path="/h1/stock-opname"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser("H1", "STOCK_OPNAME");
                                        return <StockOpname menuAccess={menuAccess}/>;
                                    }}
                                />

                                <Route
                                    exact
                                    path="/master/bank"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser("MASTERDATA", "MASTER_BANK");
                                        return <MasterBank menuAccess={menuAccess}/>;
                                    }}
                                />

                                <Route
                                    exact
                                    path="/master/part"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser("MASTERDATA", "MASTER_PART", 0);
                                        return <MasterPart menuAccess={menuAccess}/>;
                                    }}
                                />

                                <Route
                                    exact
                                    path="/master/promo"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser("MASTERDATA", "MASTER_PROMO");
                                        return <MasterPromo menuAccess={menuAccess}/>;
                                    }}
                                />

                                <Route
                                    exact
                                    path="/master/voucher"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser("MASTERDATA", "MASTER_VOUCHER", 0);
                                        return <MasterVoucher menuAccess={menuAccess}/>;
                                    }}
                                />

                                <Route
                                    exact
                                    path="/master/sales"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser("MASTERDATA", "MASTER_SALES");
                                        return <MasterPenjualan menuAccess={menuAccess}/>;
                                    }}
                                />

                                <Route
                                    exact
                                    path="/master/leasing"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser("MASTERDATA", "MASTER_LEASING");
                                        return <MasterLeasing menuAccess={menuAccess}/>;
                                    }}
                                />

                                <Route
                                    exact
                                    path="/h1/claim-c1"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser("H1", "CLAIM_C1");
                                        return <ClaimC1 menuAccess={menuAccess}/>;
                                    }}
                                />
                                <Route
                                    exact
                                    path="/master/units"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser("MASTERDATA", "MASTER_UNIT_PRICE");
                                        return <MasterUnitPrice menuAccess={menuAccess}/>;
                                    }}
                                />
                                <Route
                                    exact
                                    path="/h1/penyerahan-bbn"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser("H1", "PENYERAHAN_BBN");
                                        return <PenyerahanBBN menuAccess={menuAccess}/>;
                                    }}
                                />
                                <Route
                                    exact
                                    path="/h1/crm/follow-up-prospek"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser("H1", "CRM_FOLLOW_UP");
                                        return <CRMFollowUp menuAccess={menuAccess}/>;
                                    }}
                                />
                                <Route
                                    exact
                                    path="/h1/management-notification"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser("H1", "MANAGEMENT_NOTIFICATION");
                                        return <ManagementNotif menuAccess={menuAccess}/>;
                                    }}
                                />
                                <Route
                                    exact
                                    path="/h1/crm/manajemen-cdb"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser("H1", "CRM_CDB");
                                        return <CrmCDB menuAccess={menuAccess}/>;
                                    }}
                                />
                                <Route
                                    exact
                                    path="/h1/proses-samsat"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser("H1", "PROSES_SAMSAT");
                                        return <ProsesSamsat menuAccess={menuAccess}/>;
                                    }}
                                />
                                <Route
                                    exact
                                    path="/h1/crm/assign-prospek"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser("H1", "CRM_ASSIGN");
                                        return <CRMAssign menuAccess={menuAccess}/>;
                                    }}
                                />
                                <Route
                                    exact
                                    path="/h1/proses-ssu"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser("H1", "PROSES_SSU");
                                        return <ProsesSSU menuAccess={menuAccess}/>;
                                    }}
                                />
                                <Route
                                    exact
                                    path="/h1/cdb-profile"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser("H1", "PROSES_SSU");
                                        return <CustomerProfileCDB menuAccess={menuAccess}/>;
                                    }}
                                />

                                <Route
                                    exact
                                    path="/h1/sales-order/faktur-jual"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser("H1", "FAKTUR_JUAL");
                                        return <FakturJual menuAccess={menuAccess}/>;
                                    }}
                                />

                                <Route
                                    exact
                                    path="/h1/management-approval"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser("H1", "MANAGEMENT_APPROVAL");
                                        return <ManagementApproval menuAccess={menuAccess}/>;
                                    }}
                                />

                                <Route
                                    exact
                                    path="/h1/management-nrfs"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser("H1", "MANAGEMENT_NRFS");
                                        return <ManagementNRFS menuAccess={menuAccess}/>;
                                    }}
                                />

                                {/*Dashboard*/}
                                <Route
                                    exact
                                    path="/dashboard/cashier"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser("DASHBOARD", "DASHBOARD_CASHIER");
                                        return <DashboardCashier menuAccess={menuAccess}/>;
                                    }}
                                />

                                <Route
                                    exact
                                    path="/dashboard/sales"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser("DASHBOARD", "DASHBOARD_SALES");
                                        return <DashboardSales menuAccess={menuAccess}/>;
                                    }}
                                />

                                <Route
                                    exact
                                    path="/dashboard/sales/sales"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser("DASHBOARD", "DASHBOARD_SALES");
                                        return <SalesReport menuAccess={menuAccess}/>;
                                    }}
                                />

                                <Route
                                    exact
                                    path="/dashboard/sales/variant"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser("DASHBOARD", "DASHBOARD_SALES");
                                        return <VariantReport menuAccess={menuAccess}/>;
                                    }}
                                />

                                {/*dashboard kacab*/}
                                <Route
                                    exact
                                    path="/dashboard/kacab"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser("DASHBOARD", "DASHBOARD_KACAB");
                                        return <DashboardKacab menuAccess={menuAccess}/>;
                                    }}
                                />
                                <Route
                                    exact
                                    path="/dashboard/kacab/cabang"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser("DASHBOARD", "DASHBOARD_KACAB");
                                        return <KacabReportByCabang menuAccess={menuAccess}/>;
                                    }}
                                />
                                <Route
                                    exact
                                    path="/dashboard/kacab/team-leader"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser("DASHBOARD", "DASHBOARD_KACAB");
                                        return <KacabReportByTL menuAccess={menuAccess}/>;
                                    }}
                                />
                                <Route
                                    exact
                                    path="/dashboard/kacab/sales"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser("DASHBOARD", "DASHBOARD_KACAB");
                                        return <KacabReportBySalesman menuAccess={menuAccess}/>;
                                    }}
                                />
                                <Route
                                    exact
                                    path="/dashboard/kacab/type"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser("DASHBOARD", "DASHBOARD_KACAB");
                                        return <KacabReportByType menuAccess={menuAccess}/>;
                                    }}
                                />
                                <Route
                                    exact
                                    path="/dashboard/kacab/type-team-leader"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser("DASHBOARD", "DASHBOARD_KACAB");
                                        return <KacabReportByTypeByTL menuAccess={menuAccess}/>;
                                    }}
                                />
                                <Route
                                    exact
                                    path="/dashboard/kacab/sales-composition"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser("DASHBOARD", "DASHBOARD_KACAB");
                                        return <KacabReportBySalesComposition menuAccess={menuAccess}/>;
                                    }}
                                />
                                <Route
                                    exact
                                    path="/dashboard/kacab/sales-structure"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser("DASHBOARD", "DASHBOARD_KACAB");
                                        return <KacabReportBySalesStructure menuAccess={menuAccess}/>;
                                    }}
                                />
                                <Route
                                    exact
                                    path="/dashboard/kacab/indent"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser("DASHBOARD", "DASHBOARD_KACAB");
                                        return <KacabReportByIndent menuAccess={menuAccess}/>;
                                    }}
                                />

                                {/*dashboard crm coordinator*/}
                                <Route
                                    exact
                                    path="/dashboard/crm-coordinator"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser("DASHBOARD", "DASHBOARD_CRM_COORDINATOR");
                                        return <DashboardCrmCoordinator menuAccess={menuAccess}/>;
                                    }}
                                />
                                <Route
                                    exact
                                    path="/dashboard/crm-coordinator/team-leader-report"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser("DASHBOARD", "DASHBOARD_CRM_COORDINATOR");
                                        return <DashboardCrmCoordinatorByTL menuAccess={menuAccess}/>;
                                    }}
                                />
                                <Route
                                    exact
                                    path="/dashboard/crm-coordinator/daily-report"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser("DASHBOARD", "DASHBOARD_CRM_COORDINATOR");
                                        return <DashboardCrmCoordinatorDailyReport menuAccess={menuAccess}/>;
                                    }}
                                />

                                {/* dashboard team leader*/}
                                <Route
                                    exact
                                    path="/dashboard/team-leader"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser("DASHBOARD", "DASHBOARD_TEAM_LEADER");
                                        return <DashboardTeamLeader menuAccess={menuAccess}/>;
                                    }}
                                />
                                <Route
                                    exact
                                    path="/dashboard/team-leader/team-leader"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser("DASHBOARD", "DASHBOARD_TEAM_LEADER");
                                        return <TLReportByTL menuAccess={menuAccess}/>;
                                    }}
                                />
                                <Route
                                    exact
                                    path="/dashboard/team-leader/salesman"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser("DASHBOARD", "DASHBOARD_TEAM_LEADER");
                                        return <TLReportBySalesman menuAccess={menuAccess}/>;
                                    }}
                                />
                                <Route
                                    exact
                                    path="/dashboard/team-leader/variant"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser("DASHBOARD", "DASHBOARD_TEAM_LEADER");
                                        return <TLReportByVariant menuAccess={menuAccess}/>;
                                    }}
                                />

                                {/* dashboard accounting */}
                                <Route
                                    exact
                                    path="/dashboard/accounting"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser("DASHBOARD", "DASHBOARD_ACCOUNTING");
                                        return <DashboardAccounting menuAccess={menuAccess}/>;
                                    }}
                                />

                                {/* dashboard crm salesman */}
                                <Route
                                    exact
                                    path="/dashboard/crm-salesman"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser("DASHBOARD", "DASHBOARD_CRM_SALESMAN");
                                        return <DashboardCrmSalesman menuAccess={menuAccess}/>;
                                    }}
                                />
                                <Route
                                    exact
                                    path="/dashboard/crm-salesman/prospect-monitoring-team"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser("DASHBOARD", "DASHBOARD_CRM_SALESMAN");
                                        return <ProspectMonitoringTeam menuAccess={menuAccess}/>;
                                    }}
                                />
                                <Route
                                    exact
                                    path="/dashboard/crm-salesman/prospect-daily"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser("DASHBOARD", "DASHBOARD_CRM_SALESMAN");
                                        return <ProspectDaily menuAccess={menuAccess}/>;
                                    }}
                                />

                                {/*dashboard kacab dan Admin CRM*/}
                                <Route
                                    exact
                                    path="/dashboard/kacab-admin-crm"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser("DASHBOARD", "DASHBOARD_KACAB_ADMIN_CRM");
                                        return <DashboardKacabAdminCrm menuAccess={menuAccess}/>;
                                    }}
                                />
                                <Route
                                    exact
                                    path="/dashboard/kacab-admin-crm/prospect-monitoring"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser("DASHBOARD", "DASHBOARD_KACAB_ADMIN_CRM");
                                        return <ProspectMonitoringCrm menuAccess={menuAccess}/>;
                                    }}
                                />
                                <Route
                                    exact
                                    path="/dashboard/kacab-admin-crm/prospect-monitoring-team"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser("DASHBOARD", "DASHBOARD_KACAB_ADMIN_CRM");
                                        return <ProspectMonitoringTeamCrm menuAccess={menuAccess}/>;
                                    }}
                                />
                                <Route
                                    exact
                                    path="/dashboard/kacab-admin-crm/prospect-daily"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser("DASHBOARD", "DASHBOARD_KACAB_ADMIN_CRM");
                                        return <ProspectDailyCrm menuAccess={menuAccess}/>;
                                    }}
                                />
                                <Route
                                    exact
                                    path="/dashboard/kacab-admin-crm/prospect-monitoring-ro"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser("DASHBOARD", "DASHBOARD_KACAB_ADMIN_CRM");
                                        return <ProspectMonitoringROCrm menuAccess={menuAccess}/>;
                                    }}
                                />

                                {/*H23*/}
                                <Route
                                    exact
                                    path="/h23/mutasi-part"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser("H23", "MUTASI_PART");
                                        return <MutasiPart menuAccess={menuAccess}/>;
                                    }}
                                />

                                 <Route
                                    exact
                                    path="/h23/receiving-part"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser("H23", "RECEIVING_PART");
                                        return <ReceivingPart menuAccess={menuAccess}/>;
                                    }}
                                />
                                 
                                <Route
                                    exact
                                    path="/h23/management-mekanik"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser("H23", "MANAGEMENT_MECHANIC");
                                        return <ManagementMekanik menuAccess={menuAccess}/>;
                                    }}
                                />
                                
                                <Route
                                    exact
                                    path="/h23/management-booking"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser("H23", "MANAGEMENT_BOOKING");
                                        return <ManagementBooking menuAccess={menuAccess}/>;
                                    }}
                                />
                                
                                <Route
                                    exact
                                    path="/h23/crm/follow-up-prospek"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser("H23", "CRM_FOLLOW_UP_H23");
                                        return <CrmFollowUpH23 menuAccess={menuAccess}/>;
                                    }}
                                />
                                
                                <Route
                                    exact
                                    path="/h23/faktur-jual-bengkel"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser("H23", "FAKTUR_JUAL_BENGKEL");
                                        return <FakturJualBengkel menuAccess={menuAccess}/>;
                                    }}
                                />
                                
                                <Route
                                    exact
                                    path="/h23/management-claim"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser("H23", "MANAGEMENT_CLAIM");
                                        return <ManagementClaim menuAccess={menuAccess}/>;
                                    }}
                                />
                                
                                <Route
                                    exact
                                    path="/h23/inventory-part"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser("H23", "INVENTORY_PART");
                                        return <InventoryPart menuAccess={menuAccess}/>;
                                    }}
                                />

                                <Route
                                    exact
                                    path="/h23/po-part"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser("H23", "PO_PART");
                                        return <PoPart menuAccess={menuAccess}/>;
                                    }}
                                />

                                {/*FINANCE*/}
                                <Route
                                    exact
                                    path="/finance/payment/transaksi-bank"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser("FINANCE", "TRANSAKSI_BANK");
                                        return <TransaksiBank menuAccess={menuAccess}/>;
                                    }}
                                />
                                <Route
                                    exact
                                    path="/finance/payment/transaksi-cash"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser("FINANCE", "TRANSAKSI_CASH");
                                        return <TransaksiCash menuAccess={menuAccess}/>;
                                    }}
                                />
                                <Route
                                    exact
                                    path="/finance/penagihan-leasing"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser("FINANCE", "PENAGIHAN_LEASING");
                                        return <SalesOrder menuAccess={menuAccess}/>;
                                    }}
                                />
                                
                                {/*DASHBOARD H23*/}
                                {/*DASHBOARD Kacab Kabeng CRM*/}
                                <Route
                                    exact
                                    path="/dashboard/crm-kabeng-kacab"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser("DASHBOARD_H23", "DASHBOARD_CRM_KACAB_KABENG_ADMIN_CRM");
                                        return <DashboardCRMKabengKacab menuAccess={menuAccess}/>;
                                    }}
                                />
                                <Route
                                    exact
                                    path="/dashboard/crm-kabeng-kacab/prospek-monitoring"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser("DASHBOARD_H23", "DASHBOARD_CRM_KACAB_KABENG_ADMIN_CRM");
                                        return <DashboardProspekMonitoringKabengKacab menuAccess={menuAccess}/>;
                                    }}
                                />
                                <Route
                                    exact
                                    path="/dashboard/crm-kabeng-kacab/prospek-daily"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser("DASHBOARD_H23", "DASHBOARD_CRM_KACAB_KABENG_ADMIN_CRM");
                                        return <DashboardProspekDailyKabengKacab menuAccess={menuAccess}/>;
                                    }}
                                />
                                <Route
                                    exact
                                    path="/dashboard/crm-kabeng-kacab/monitoring-ro"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser("DASHBOARD_H23", "DASHBOARD_CRM_KACAB_KABENG_ADMIN_CRM");
                                        return <DashboardMonitoringROKabengKacab menuAccess={menuAccess}/>;
                                    }}
                                />
                                <Route
                                    exact
                                    path="/dashboard/crm-kabeng-kacab/monitoring-kpb"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser("DASHBOARD_H23", "DASHBOARD_CRM_KACAB_KABENG_ADMIN_CRM");
                                        return <DashboardMonitoringKPBKabengKacab menuAccess={menuAccess}/>;
                                    }}
                                />
                                <Route
                                    exact
                                    path="/dashboard/crm-kabeng-kacab/monitoring-tambahan"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser("DASHBOARD_H23", "DASHBOARD_CRM_KACAB_KABENG_ADMIN_CRM");
                                        return <DashboardMonitoringTambahanKabengKacab menuAccess={menuAccess}/>;
                                    }}
                                />

                                {/*DASHBOARD Level Mekanik dan SA*/}
                                <Route
                                    exact
                                    path="/dashboard/level-mekanik-sa"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser("DASHBOARD_H23", "DASHBOARD_MEKANIK_SA");
                                        return <DashboardLevelMekanikSA menuAccess={menuAccess}/>;
                                    }}
                                />
                                <Route
                                    exact
                                    path="/dashboard/level-mekanik-sa/laporan-harian-unit-monitoring"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser("DASHBOARD_H23", "DASHBOARD_MEKANIK_SA");
                                        return <DashboardLaporanHarianUnit menuAccess={menuAccess}/>;
                                    }}
                                />

                                <Route
                                    exact
                                    path="/dashboard/level-mekanik-sa/laporan-harian-part-monitoring"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser("DASHBOARD_H23", "DASHBOARD_MEKANIK_SA");
                                        return <DashboardLaporanHarianPartByMekanikdanSA menuAccess={menuAccess}/>;
                                    }}
                                />
                                
                                <Route
                                    exact
                                    path="/dashboard/level-kabeng-keatas"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser("DASHBOARD_H23", "DASHBOARD_KABENG_KEATAS");
                                        return <DashboardLevelKabengKeatas menuAccess={menuAccess}/>;
                                    }}
                                />
                                
                                <Route
                                    exact
                                    path="/dashboard/level-kabeng-keatas/laporan-harian-unit-by-cabang"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser("DASHBOARD_H23", "DASHBOARD_KABENG_KEATAS");
                                        return <DashboardLaporanHarianUnitByCabang menuAccess={menuAccess}/>;
                                    }}
                                />
                                
                                <Route
                                    exact
                                    path="/dashboard/level-kabeng-keatas/laporan-harian-unit-by-mekanik"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser("DASHBOARD_H23", "DASHBOARD_KABENG_KEATAS");
                                        return <DashboardLaporanHarianUnitByMekanik menuAccess={menuAccess}/>;
                                    }}
                                />

                                <Route
                                    exact
                                    path="/dashboard/level-kabeng-keatas/laporan-harian-part-by-cabang"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser("DASHBOARD_H23", "DASHBOARD_KABENG_KEATAS");
                                        return <DashboardLaporanHarianPartByCabang menuAccess={menuAccess}/>;
                                    }}
                                />

                                <Route
                                    exact
                                    path="/dashboard/level-kabeng-keatas/laporan-harian-part-by-mekanik"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser("DASHBOARD_H23", "DASHBOARD_KABENG_KEATAS");
                                        return <DashboardLaporanHarianPartByMekanik menuAccess={menuAccess}/>;
                                    }}
                                />

                                <Route
                                    exact
                                    path="/dashboard/level-kabeng-keatas/laporan-tambahan"
                                    render={() => {
                                        const menuAccess = this.getMenuAccessForUser("DASHBOARD_H23", "DASHBOARD_KABENG_KEATAS");
                                        return <DashboardLaporanTambahan menuAccess={menuAccess}/>;
                                    }}
                                />

                                <Route exact path="/master/user-matrix" component={User}/>
                                <Route exact path="/master/bank-matrix" component={Bank}/>
                                <Route exact path="/master/varian-matrix" component={varian}/>
                                <Route exact path="/master/jasa-matrix" component={jasa}/>
                                <Route exact path="/master/pit-matrix" component={pit}/>
                                <Route exact path="/master/units-matrix" component={units}/>
                                <Route exact path="/master/item-matrix" component={item}/>
                                <Route exact path="/master/access-matrix" component={access}/>
                                <Route exact path="/master/part-matrix" component={part}/>
                                <Route exact path="/master/mksu-matrix" component={mksu}/>
                                <Route exact path="/master/poin-matrix" component={poin}/>
                                <Route exact path="/master/package-matrix" component={_package}/>
                                <Route exact path="/master/pricelist-matrix" component={pricelist}/>
                                <Route exact path="/master/promo-matrix" component={promo}/>
                                <Route exact path="/master/discount-matrix" component={discount}/>
                                <Route exact path="/master/leasing-matrix" component={leasing}/>
                                <Route exact path="/master/notifikasi-matrix" component={notifikasi}/>
                                <Route exact path="/master/parameter-matrix" component={parameter}/>
                                <Route exact path="/master/wilayah-matrix" component={wilayah}/>
                                <Route exact path="/master/samsat-matrix" component={samsat}/>
                                <Route exact path="/master/batery-matrix" component={batery}/>
                                <Route exact path="/master/supplier-matrix" component={supplier}/>
                                <Route exact path="/master/voucher-matrix" component={voucher}/>
                                <Route exact path="/master/warehouse-matrix" component={warehouse}/>
                                {/* Dashboard */}
                                <Route exact path="/home" component={DashboardEmployee}/>
                                <Route
                                    exact
                                    path="/home/dashUserManagement-matrix"
                                    component={DashboardUserManagement}
                                />
                                <Route
                                    exact
                                    path="/home/dashBankManagement-matrix"
                                    component={DashboardBankManagement}
                                />
                                <Route exact path="/home/dashVarian-matrix" component={DashboardVarian}/>
                                <Route exact path="/home/dashBranch-matrix" component={DashboardBranch}/>
                                <Route exact path="/home/dashRecUnit-matrix" component={DashboardRecUnit}/>
                                <Route exact path="/home/dashDelivery-matrix" component={DashboardDelivery}/>
                                <Route exact path="/home/dashRecPart-matrix" component={DashboardRecPart}/>
                                <Route exact path="/home/dashMSIC-matrix" component={dashboardMSIC}/>
                                <Route
                                    exact
                                    path="/home/dashUnitMovement-matrix"
                                    component={dashboardUnitMovement}
                                />
                                <Route exact path="/home/dashMasterJasa-matrix" component={dashboardMasterJasa}/>
                                <Route exact path="/home/dashWarehouse-matrix" component={dashboardWarehouse}/>
                                <Route exact path="/home/dashPit-matrix" component={dashboardPit}/>

                                {/* Cabang */}
                                <Route exact path="/master/cabang-matrix" component={Cabang}/>
                                <Route exact path="/h1Module/report-matrix" component={reportH1}/>
                                <Route exact path="/h1Module/receivingUnit-matrix" component={receivingUnit}/>
                                <Route exact path="/h1Module/delivery-matrix" component={delivery}/>
                                <Route exact path="/h1Module/inventory-matrix" component={inventory}/>
                                <Route exact path="/h1Module/payment-matrix" component={payment}/>
                                <Route exact path="/h1Module/unitMovement-matrix" component={unitMovement}/>
                                <Route exact path="/h1Module/stockOpname-matrix" component={stockOpname}/>
                                <Route exact path="/h1Module/miscInOut-matrix" component={MiscInOutH1}/>
                                <Route exact path="/h1Module/ksu-matrix" component={ksu}/>
                                <Route exact path="/h1Module/return-matrix" component={_return}/>
                                <Route exact path="/h1Module/fandb-matrix" component={fandb}/>
                                <Route exact path="/h1Module/kas-matrix" component={kas}/>
                                <Route exact path="/h1Module/prospek-matrix" component={prospek}/>
                                <Route exact path="/h1Module/data-matrix" component={data}/>
                                <Route exact path="/h1Module/claimC1-matrix" component={claimC1}/>
                                <Route exact path="/h1Module/order-matrix" component={order}/>
                                {/* h2 module */}
                                <Route exact path="/h2Module/PDI-matrix" component={PDI}/>
                                <Route exact path="/h2Module/report-matrix" component={reportH2}/>
                                <Route exact path="/h2Module/workOrder-matrix" component={workOrder}/>
                                <Route exact path="/h2Module/claimC3-matrix" component={claimC3}/>
                                {/* h3 module */}
                                <Route exact path="/h3Module/report-matrix" component={reportH3}/>
                                <Route exact path="/h3Module/receivingPart-matrix" component={receivingPart}/>
                                <Route exact path="/h3Module/receivingItems-matrix" component={receivingItems}/>
                                <Route exact path="/h3Module/miscInOut-matrix" component={miscInOut}/>
                                <Route exact path="/h3Module/inventory-matrix" component={inventoryh3}/>
                                <Route exact path="/h3Module/unitMovement-matrix" component={unitMovementh3}/>
                                <Route exact path="/h3Module/procurement-matrix" component={procurement}/>
                                <Route exact path="/h3Module/stockOpname-matrix" component={stockOpnameh3}/>
                                <Route exact path="/h3Module/payment-matrix" component={paymentH3}/>
                                <Route exact path="/h3Module/prospek-matrix" component={prospekH3}/>
                            </div>
                        </div>
                    </div>
                    {/* Single Page */}
                    {/* <div className="app">
        <Route exact path="/" component={Login} />
      </div> */}
                    <ErrorAlert/>
                </div>
            );
        } else {
            content = (
                <Switch>
                    <Route exact path="/" component={Login}/>
                    <Redirect to="/"/>
                </Switch>
            );
        }

        return <HashRouter history={Router.browserHistory}>{content}</HashRouter>;
    }
}

const mapStateToProps = (state) => {
    return {
        auth: state.auth,
    };
};

export default connect(mapStateToProps, null)(App);